<div class="loading-overlay" *ngIf="showLoaderOverlay" style="height:{{ overlayHeight }}"></div>
<router-outlet></router-outlet>
